export default __webpack_public_path__ + "static/grain-4a09aa399b1f3e0c6ba94c688e9e1f9d.png";